<template>
  <div class="safe-markdown" v-html="html"></div>
</template>

<script>
import { marked } from 'marked';
import createDOMPurify from 'dompurify';

/**
 * Vue 2 drop-in replacement for vue-markdown (EOL / HIGH CVE).
 * Props/events mirror vue-markdown enough for existing call sites:
 * - source, task-lists
 * - @rendered
 */
const purify = (typeof window !== 'undefined')
  ? (createDOMPurify.sanitize ? createDOMPurify : createDOMPurify(window))
  : null;

export default {
  name: 'SafeMarkdown',
  props: {
    source: {
      type: String,
      default: '',
    },
    // Kept for API compatibility with vue-markdown; GFM task lists stay off by default.
    taskLists: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      html: '',
    };
  },
  watch: {
    source: {
      immediate: true,
      handler(value) {
        this.renderMarkdown(value);
      },
    },
    taskLists() {
      this.renderMarkdown(this.source);
    },
  },
  methods: {
    renderMarkdown(value) {
      const raw = marked.parse(value || '', {
        async: false,
        gfm: true,
        breaks: false,
      });
      const html = typeof raw === 'string' ? raw : String(raw);
      this.html = purify && purify.sanitize
        ? purify.sanitize(html)
        : html.replace(/</g, '&lt;');
      this.$nextTick(() => {
        this.$emit('rendered');
      });
    },
  },
};
</script>
